import { render, staticRenderFns } from "./ui-tag.vue?vue&type=template&id=7ba9cf8b&scoped=true&"
import script from "./ui-tag.vue?vue&type=script&lang=js&"
export * from "./ui-tag.vue?vue&type=script&lang=js&"
import style0 from "./ui-tag.vue?vue&type=style&index=0&id=7ba9cf8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba9cf8b",
  null
  
)

export default component.exports